<template>
<!-- 新增按钮 -->
  <el-dialog
    :title="$t('pages.system.text111')"
    :visible.sync="dialogButtoVisible"
    width="650px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="auto"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('pages.system.text112')" prop="buttonName">
          <el-input v-model="ruleForm.buttonName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text113')" prop="perms">
          <el-input v-model="ruleForm.perms"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('button.cancel')}}</el-button>
      <el-button type="primary" @click="submit">{{$t('button.determine')}}</el-button>
    </span>
  </el-dialog>
</template>


<script>
export default {
  data() {
    return {
      ruleForm: {
        buttonName: "", //按钮名称
        perms: "", //按钮权限编码
        pid: "", //按钮的父节点
        status: 0, //状态，是否启用
      },
      rules: {
        buttonName: [
          { required: true, message: this.$t('pages.system.text114'), trigger: "blur" },
        ],
        perms: [{ required: true, message: this.$t('pages.system.text115'), trigger: "blur" }],
      },
    };
  },
  watch: {
    dialogButtoVisible() {
      this.ruleForm.pid = null;
      this.ruleForm.id = null;
      this.ruleForm.buttonName = null;
      this.ruleForm.perms = null;
      if (this.isButtonAdd) {
        this.ruleForm.pid = this.currentMenu.id;
      } else {
        this.ruleForm.pid = this.currentMenu.menuPid;
        this.ruleForm.id = Math.abs(this.currentMenu.id);
        this.ruleForm.buttonName = this.currentMenu.menuName;
        this.ruleForm.perms = this.currentMenu.url;
      }
    },
  },
  props: ["dialogButtoVisible", "currentMenu", "isButtonAdd"],
  methods: {
    //取消
    handleClose() {
      this.$emit("dialogButtoClose");
    },
    //确定
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.isButtonAdd) {
            this.request.menuManagementAddButton(this.ruleForm).then(() => {
              this.$message.success(this.$t('pages.system.text116'));
              this.handleClose();
              this.$emit("listWithButtons");
            });
          } else {
            this.request.menuManagementEditButton(this.ruleForm).then(() => {
              this.$message.success(this.$t('pages.system.text117'));
              this.handleClose();
              this.$emit("listWithButtons");
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
}
</style>
